<template>
  <div style="padding: 24px;">
    <a-spin :spinning="newsSpinning">
      <document-list :arrs="arrs" url="/documentItem/"></document-list>
      <div class="pagination">
        <a-pagination show-quick-jumper :default-current="1" :total="total" :current="pageNo" :pageSize="pageSize" @change="onChange" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import documentList from "../documentcenter/component/documentList.vue";
export default {
  data() {
    return {
      newsSpinning: false,
      arrs: [],
      pageNo: 1,
      pageSize: 10,
      total: 0
    };
  },
  components: {
    documentList
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    getDetailInfo() {
      this.newsSpinning = true;
      this.axios
        .get(
          `/biz/home/document/list?pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        )
        .then(res => {
          if (res.success) {
            this.total = res.result.total;
            this.arrs = res.result.records;
          }
        })
        .finally(() => {
          this.newsSpinning = false;
        });
    },
    onChange(index) {
      this.pageNo = index;
      this.getDetailInfo();
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/documentList/index.vue